import type { ToggleDataLocalCache } from './toggleCache';

export const safeSetHas = <T>(set: Set<string>, value: T): boolean => {
    if (set === undefined || set === null) {
        return false;
    }
    return set.has(`${value}`);
};

export const calcNonSimpleToggleEnabledState = (
    dealerId: string | null,
    userId: string | null,
    customId: string | null,
    dealerIds: Set<string>,
    userIds: Set<string>,
    customIds: Set<string>,
    enabled: boolean
): boolean => {
    if (!dealerId && !userId && !customId) {
        return false;
    } else if (safeSetHas(dealerIds, dealerId) || safeSetHas(userIds, userId) || safeSetHas(customIds, customId)) {
        return enabled;
    } else {
        return false;
    }
};

export const isToggleEnabled = (
    toggleDataLocalCache: ToggleDataLocalCache,
    toggleName: string,
    dealerId: string | null,
    userId: string | null,
    customId: string | null
): boolean | null => {
    if (!toggleDataLocalCache) {
        return null;
    }
    const toggleData = toggleDataLocalCache[toggleName];
    if (!toggleData) {
        return null;
    }
    const simpleToggle = !toggleData.dealerIds?.size && !toggleData.userIds?.size && !toggleData.customIds?.size;
    if (simpleToggle) {
        return toggleData.enabled;
    } else {
        return calcNonSimpleToggleEnabledState(
            dealerId,
            userId,
            customId,
            toggleData.dealerIds,
            toggleData.userIds,
            toggleData.customIds,
            toggleData.enabled
        );
    }
};
